import React from "react";
import "new_components/Home/Home.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import FlatSlider from "./FlatSlider";
import MarketOpportunitySection from "./MarketAndOpportunity";
import InvestmentPhilosophy from "./InvestmentPhilosophy";
// import OurOfferings from "./OurOfferings";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import HomeBottomBanner from "./HomeBottomBanner";
import WhatWeDo from "./WhatWeDo";
import ExpertiseSection from "./OurExpertise";
const Home = () => {
  return (
    <>
      <ScrollToTopDefault />
      <Header />
      <ProgressCircle />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <FlatSlider />
      <WhatWeDo />

      <MarketOpportunitySection />

      <ExpertiseSection />
      <InvestmentPhilosophy />

      {/* <OurOfferings /> */}
      <HomeBottomBanner />
    </div>
  );
};

export default Home;
